/*******************************************************************************
 * Licensed Materials - Property of IBM
 * (c) Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * Note to U.S. Government Users Restricted Rights:
 * Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 *******************************************************************************/
'use strict';

module.exports = {
  isTodayAfter: function isTodayAfter(date) {
    if (!date) return false;
    var thisDate = new Date(date);
    if (thisDate.toString() === 'Invalid Date') return false;
    return new Date() > thisDate;
  }
};